import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { useState, useCallback, useEffect } from 'react';
import { RemoveScroll } from 'react-remove-scroll';
import { Portal } from '../../primitives/Portal/Portal.es.js';
import { Overlay } from '../Overlay/Overlay.es.js';
import { Fade } from '../Fade/Fade.es.js';
import '../MaestroThemeProvider/MaestroThemeProvider.es.js';
import { ColorMode } from '../MaestroThemeProvider/ColorMode.es.js';
import '../MaestroThemeProvider/ExperimentalProvider/ExperimentalProvider.es.js';
import { forwardRef } from '../../system/forwardRef.es.js';
import { Wrapper, Modal as Modal$1 } from './styled.es.js';
import { ModalContext } from './ModalContext.es.js';
import { ModalFooter, ModalContinueButton, ModalCancelButton } from './ModalFooter.es.js';
import { ModalHeader, ModalCloseButton, ModalTitle, ModalBackButton } from './ModalHeader.es.js';
import { ModalContent } from './ModalContent.es.js';
import { ModalSection } from './ModalSection.es.js';
import { useModal } from './useModal.es.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var TRANSITION_DURATION = 300;
var ModalComponent = forwardRef(function (props, ref) {
  var _a = props,
      children = _a.children,
      _a$variant = _a.variant,
      variant = _a$variant === void 0 ? "base" : _a$variant,
      _a$size = _a.size,
      size = _a$size === void 0 ? "md" : _a$size,
      _a$isCentered = _a.isCentered,
      isCentered = _a$isCentered === void 0 ? true : _a$isCentered,
      _a$isOpen = _a.isOpen,
      isOpen = _a$isOpen === void 0 ? false : _a$isOpen,
      _a$withOverlay = _a.withOverlay,
      withOverlay = _a$withOverlay === void 0 ? true : _a$withOverlay,
      onOpen = _a.onOpen,
      _a$onClose = _a.onClose,
      onClose = _a$onClose === void 0 ? function () {
    return void 0;
  } : _a$onClose,
      _a$showCloseButton = _a.showCloseButton,
      showCloseButton = _a$showCloseButton === void 0 ? true : _a$showCloseButton,
      _a$closeOnOverlayClic = _a.closeOnOverlayClick,
      closeOnOverlayClick = _a$closeOnOverlayClic === void 0 ? true : _a$closeOnOverlayClic,
      _a$isDismissible = _a.isDismissible,
      isDismissible = _a$isDismissible === void 0 ? true : _a$isDismissible,
      _a$theme = _a.theme,
      themeMode = _a$theme === void 0 ? "light" : _a$theme,
      _a$scrollBehavior = _a.scrollBehavior,
      scrollBehavior = _a$scrollBehavior === void 0 ? "inside" : _a$scrollBehavior,
      _a$transitionComponen = _a.transitionComponent,
      TransitionComponent = _a$transitionComponen === void 0 ? Fade : _a$transitionComponen,
      _a$initialFocusRef = _a.initialFocusRef,
      initialFocusRef = _a$initialFocusRef === void 0 ? null : _a$initialFocusRef,
      _a$zIndex = _a.zIndex,
      zIndex = _a$zIndex === void 0 ? 1e3 : _a$zIndex,
      rest = __objRest(_a, ["children", "variant", "size", "isCentered", "isOpen", "withOverlay", "onOpen", "onClose", "showCloseButton", "closeOnOverlayClick", "isDismissible", "theme", "scrollBehavior", "transitionComponent", "initialFocusRef", "zIndex"]);

  var _useState = useState(false),
      isMounted = _useState[0],
      setIsMounted = _useState[1];

  var handleEnter = function handleEnter() {
    return onOpen == null ? void 0 : onOpen();
  };

  var handleExited = function handleExited() {
    return setIsMounted(false);
  };

  var handleEntered = useCallback(function () {
    var _a2, _b;

    (_b = (_a2 = initialFocusRef == null ? void 0 : initialFocusRef.current) == null ? void 0 : _a2.focus) == null ? void 0 : _b.call(_a2);
  }, [initialFocusRef]);
  var modal = useModal({
    isOpen: isOpen,
    onClose: onClose,
    closeOnOverlayClick: closeOnOverlayClick,
    isDismissible: isDismissible
  });

  var context = __spreadProps(__spreadValues({}, modal), {
    onClose: onClose,
    showCloseButton: showCloseButton,
    variant: variant,
    size: size,
    scrollBehavior: scrollBehavior,
    isCentered: isCentered
  });

  useEffect(function () {
    if (isOpen) {
      setIsMounted(true);
    }
  }, [isOpen]);
  return (
    /* @__PURE__ */
    React.createElement(ModalContext.Provider, {
      value: context
    }, isMounted &&
    /* @__PURE__ */
    React.createElement(Portal, {
      zIndex: zIndex
    },
    /* @__PURE__ */
    React.createElement(ColorMode, {
      mode: themeMode
    }, withOverlay &&
    /* @__PURE__ */
    React.createElement(Overlay, {
      isVisible: isOpen,
      timeout: TRANSITION_DURATION,
      zIndex: 0
    }),
    /* @__PURE__ */
    React.createElement(RemoveScroll, null,
    /* @__PURE__ */
    React.createElement(TransitionComponent, {
      in: isOpen,
      timeout: TRANSITION_DURATION,
      onEnter: handleEnter,
      onExited: handleExited,
      onEntered: handleEntered
    },
    /* @__PURE__ */
    React.createElement(Wrapper, __spreadValues({
      ref: ref,
      scrollBehavior: scrollBehavior,
      isCentered: isCentered
    }, context.getModalWrapperProps()),
    /* @__PURE__ */
    React.createElement(Modal$1, __spreadValues({
      size: context.size,
      scrollBehavior: context.scrollBehavior
    }, context.getModalProps(rest)), children)))))))
  );
});
var Modal = Object.assign(ModalComponent, {
  Header: ModalHeader,
  Content: ModalContent,
  Section: ModalSection,
  Media: ModalSection,
  Footer: ModalFooter,
  CloseButton: ModalCloseButton,
  Title: ModalTitle,
  BackButton: ModalBackButton,
  ContinueButton: ModalContinueButton,
  CancelButton: ModalCancelButton
});
Modal.displayName = "Modal";
export { Modal };